import { OverlayModule } from '@angular/cdk/overlay';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import {
    AlertTriangle, ArrowLeftCircle, ArrowRight, Building2, CalendarDays, CalendarFold, CalendarOff, Camera, Check, CheckCircle, ChevronDown, ChevronLeft, ChevronRight, ChevronUp,
    ChevronsUpDown, CircleArrowRight,
    ClipboardCheck, ClipboardCopy, ClipboardSignature, Clock, CloudCheck, CloudOff, Coins, Construction,
    Contact,
    DoorOpen,
    Download,
    Eraser,
    ExternalLink, Eye, EyeOff,
    File, FileArchive, FileBarChart2, FileCog, FilePlus2, Files, FileSpreadsheet, FileText, FileType, FileX, Flag, Folder, FolderInput, FolderOpen, FolderPlus, FolderTree,
    HardDrive, HelpCircle, History, Home, Image, Inbox,
    LayoutList, Link2,
    ListOrdered, Loader, LoaderCircle, Lock,
    LockIcon, LogOut,
    LucideAngularModule,
    Mail, MapPin, MessageSquare,
    MinusSquare,
    MoreVertical,
    Music,
    PanelLeftClose, PanelLeftOpen, Paperclip,
    Pencil, Phone, Plus, Puzzle, RefreshCcw,
    RefreshCw, RotateCcw, Save,
    Search, SearchX, Server,
    Settings2, ShieldCheck, Siren,
    Table2,
    Trash2, Unlock, Upload, User, Users2,
    Video,
    Wrench, X, XCircle, Zap
} from 'lucide-angular';

import { AppComponent } from './app/app.component';
import { APP_ROUTES } from './app/app.routes';
import { AuthInterceptor } from './app/common/auth.interceptor';
import { provideZard } from './app/shared/core/provider/providezard';

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, {
  providers: [
    provideZard(),
    provideRouter(APP_ROUTES),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    importProvidersFrom(
      OverlayModule,
      LucideAngularModule.pick({
        Home,
        FileBarChart2,
        Plus,
        Wrench,
        FilePlus2,
        Construction,
        CheckCircle,
        Check,
        Trash2,
        Pencil,
        Coins,
        Save,
        ChevronDown,
        ChevronUp,
        Users2,
        Puzzle,
        ClipboardSignature,
        Flag,
        X,
        FileText,
        ArrowLeftCircle,
        ArrowRight,
        LogOut,
        Unlock,
        Lock,
        RefreshCw,
        RefreshCcw,
        // Modul „Wartungen": Ordner rauslegen.
        ClipboardCheck,
        ClipboardCopy,
        AlertTriangle,
        ShieldCheck,
        MinusSquare,
        XCircle,
        RotateCcw,
        Eye,
        EyeOff,
        MessageSquare,
        Contact,
        CircleArrowRight,
        LockIcon,
        CloudCheck,
        CloudOff,
        FileCog,
        Eraser,
        LoaderCircle,
        Loader,
        Folder,
        FolderOpen,
        FolderPlus,
        FolderTree,
        FolderInput,
        Files,
        File,
        FileArchive,
        FileSpreadsheet,
        FileType,
        FileX,
        ExternalLink,
        HardDrive,
        HelpCircle,
        History,
        Image,
        Inbox,
        LayoutList, Link2,
        ListOrdered,
        Music,
        Paperclip,
        Video,
        ChevronLeft,
        ChevronRight,
        Upload,
        Download,
        Settings2,
        Table2,
        Zap,
        Search,
        SearchX,
        Siren,
        DoorOpen,
        CalendarOff,
        User,
        ChevronsUpDown,
        Building2,
        CalendarDays,
        CalendarFold,
        Camera,
        MapPin,
        Clock,
        Server,
        MoreVertical,
        Mail,
        Phone,
        PanelLeftClose,
        PanelLeftOpen
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: LOCALE_ID, useValue: 'de' }
  ]
}).catch(err => console.error(err));
